import React from "react";

const styles = {
  "Best Seller":   "bg-amber-50 text-amber-700 border border-amber-200",
  "New":           "bg-emerald-50 text-emerald-700 border border-emerald-200",
  "Sale":          "bg-rose-50 text-rose-600 border border-rose-200",
  "Limited Stock": "bg-orange-50 text-orange-700 border border-orange-200",
  default:         "bg-gray-50 text-gray-600 border border-gray-200",
};

const Badge = ({ label, className = "" }) => (
  <span className={`badge font-display ${styles[label] || styles.default} ${className}`}>
    {label}
  </span>
);

export default Badge;
